export default "__VITE_ASSET__BKFhjIX3__"